import React, { useState } from "react";
import { PageWrapper } from "../containers";
import FeedbackDataAndGraphs from "../containers/feedback-data/FeedbackDataAndGraphs";



export const Feedback = () => {
  const [ isLoading, setIsLoading ] = useState(false);

  return <PageWrapper loading={isLoading} pageContainerChildren={
    <>
        <FeedbackDataAndGraphs />
    </>
  } />;
};

export default Feedback;
